<template>
  <v-container>
    <h1>Welcome</h1>
  </v-container>
</template>

<script>
export default {
  name: "Home",

  components: {},
};
</script>
